import { choreApproveTranslateEs } from "@pages/parents/pages/chores/pages/chore-approve/translate/es";
import { choreManageTranslateEs } from "@pages/parents/pages/chores/pages/chore-manage/translate/es";
import { choreDisabledTranslateEs } from "@pages/parents/pages/chores/pages/chores-disabled/translate/es";
import { choreViewTranslateEs } from "@pages/parents/pages/chores/pages/view-chore/translate/es";
import { chorePageTranslateEs } from "@pages/parents/pages/chores/translate/es";


export const choresTranslateEs = {
    CHORES:{
        ...chorePageTranslateEs,
        ...choreApproveTranslateEs,
        ...choreManageTranslateEs,
        ...choreViewTranslateEs,
        ...choreDisabledTranslateEs
    }
}